/**
 * 商机详情相关接口
 */
import { pbrAxios } from '../../common/js/pbrAxios'

/**
 * 商机详情页——获取基本信息接口
 * @param params
 * @param {String}params.userid: 用户编号
 * @param {String}params.id: 商机编号
 * @param {String}params.from: 来源  en:英文  cn:中文  其他：中文
 * @returns {AxiosPromise<any>}
 */
const fetchBusinessDetail = params => {
  return pbrAxios.post('/front/business/detail', params)
}

/**
 * 商机详情页——获取相关信息接口
 * @param params
 * @param {String}params.id: 商机编号
 * @param {String}params.from: 来源  en:英文  cn:中文  其他：中文
 * @returns {AxiosPromise<any>}
 */
const fetchBusinessRinfos = params => {
  return pbrAxios.post('/front/business/rinfos', params)
}

/**
 * 商机详情页——阅读次数加1接口
 *
 * @param params
 * @param {String}params.userid: 用户编号
 * @param {String}params.id: 商机编号
 * @returns {AxiosPromise<any>}
 */
const addBusinessDetailReadTimes = params => {
  return pbrAxios.post('/front/business/read', params)
}

export default {
  fetchBusinessDetail,
  fetchBusinessRinfos,
  addBusinessDetailReadTimes
}
